import React from 'react'

class UplayRedirect extends React.Component {
  componentDidMount() {
    window.parent.postMessage('uplayRedirect', '*')
  }

  render() {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          fontFamily: 'sans-serif',
        }}
      >
        <p>Authenticating...</p>
      </div>
    )
  }
}

export default UplayRedirect
